module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('b-navbar', {
    attrs: {
      "toggleable": "",
      "type": "inverse",
      "variant": "warning"
    }
  }, [_c('div', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('b-button', {
    staticClass: "TopPanelButtons",
    attrs: {
      "size": "",
      "variant": "link",
      "href": ""
    }
  }, [_vm._v("\n            Home\n          ")])], 1), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/getstarted"
    }
  }, [_c('b-button', {
    staticClass: "TopPanelButtons",
    attrs: {
      "size": "",
      "variant": "link",
      "href": ""
    }
  }, [_vm._v("\n            Get Started\n          ")])], 1), _vm._v(" "), _c('b-button', {
    staticClass: "TopPanelButtons",
    attrs: {
      "size": "",
      "variant": "link",
      "href": ""
    }
  }, [_vm._v("\n          Profile\n        ")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/findmatch"
    }
  }, [_c('b-button', {
    staticClass: "TopPanelButtons",
    attrs: {
      "size": "",
      "variant": "link",
      "href": ""
    }
  }, [_vm._v("\n            Find Pair\n          ")])], 1), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/contactus"
    }
  }, [_c('b-button', {
    staticClass: "TopPanelButtons",
    attrs: {
      "size": "",
      "variant": "link",
      "href": ""
    }
  }, [_vm._v("\n            Contact Us\n          ")])], 1), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/techstack"
    }
  }, [_c('b-button', {
    staticClass: "TopPanelButtons",
    attrs: {
      "size": "",
      "variant": "link",
      "href": ""
    }
  }, [_vm._v("\n            Tech Stack\n          ")])], 1), _vm._v(" "), _c('b-button', {
    staticClass: "SignInButton hvr-grow",
    attrs: {
      "size": "lg",
      "variant": "success",
      "href": ""
    }
  }, [_vm._v("\n          Log In\n        ")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/signup"
    }
  }, [_c('b-button', {
    staticClass: "SignUpButton hvr-grow",
    attrs: {
      "size": "lg",
      "variant": "danger",
      "href": ""
    }
  }, [_vm._v("\n            Sign Up\n          ")])], 1)], 1)]), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-25441132","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 40
// module chunks = 0